import {
  accessWindow,
  type GetShiftAccessWindowsResponse,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const getShiftAccessWindowsResponse = z.object({
  data: z.array(accessWindow),
});

interface GetShiftAccessWindowsParams {
  shiftId: string;
}

export function useGetShiftAccessWindows<TTransformedData = GetShiftAccessWindowsResponse>(
  params: GetShiftAccessWindowsParams,
  options: UseGetQueryOptions<GetShiftAccessWindowsResponse, AxiosError, TTransformedData> = {}
): UseQueryResult<TTransformedData> {
  const { shiftId } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/shift/${shiftId}/access-windows`,
    responseSchema: getShiftAccessWindowsResponse,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_SHIFT_ACCESS_WINDOWS_FAILURE,
    },
    ...options,
  });
}
